// Ensure React is loaded FIRST before any other imports that might use use-sync-external-store-shim
import React from "react";

// Make React available globally for shims that need it
if (typeof window !== 'undefined') {
  window.React = React;
}

import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import "./styles/compact.css";

// Enable compact mode by default (can be toggled via DensityToggle)
if (typeof window !== 'undefined') {
  const savedDensity = localStorage.getItem('density');
  const isCompact = savedDensity === null || savedDensity === 'compact';
  if (isCompact) {
    document.body.classList.add('compact');
  }

  // Suppress harmless browser extension errors in console
  // These errors are from ad blockers and browser extensions, not our application
  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args) => {
    const errorMessage = args.join(' ');
    
    // Suppress Cloudflare Insights beacon errors (blocked by ad blockers)
    if (errorMessage.includes('ERR_BLOCKED_BY_CLIENT') || 
        errorMessage.includes('cloudflareinsights.com') ||
        errorMessage.includes('beacon.min.js')) {
      return; // Silently ignore
    }
    
    // Suppress browser extension content script errors
    if (errorMessage.includes('contentscript.bundle.js') ||
        errorMessage.includes('Could not establish connection') ||
        errorMessage.includes('Receiving end does not exist')) {
      return; // Silently ignore
    }
    
    // Call original error handler for real errors
    originalError.apply(console, args);
  };

  console.warn = (...args) => {
    const warnMessage = args.join(' ');
    
    // Suppress browser extension warnings
    if (warnMessage.includes('contentscript.bundle.js') ||
        warnMessage.includes('Could not establish connection') ||
        warnMessage.includes('Receiving end does not exist')) {
      return; // Silently ignore
    }
    
    // Call original warn handler for real warnings
    originalWarn.apply(console, args);
  };

  // Suppress unhandled promise rejections from browser extensions
  window.addEventListener('unhandledrejection', (event) => {
    const errorMessage = event.reason?.message || String(event.reason || '');
    
    if (errorMessage.includes('Could not establish connection') ||
        errorMessage.includes('Receiving end does not exist') ||
        errorMessage.includes('contentscript.bundle.js')) {
      event.preventDefault(); // Suppress the error
      return;
    }
  });
}

// Safety check: ensure React is available
if (!React || typeof React.useState !== 'function') {
  console.error('React is not loaded correctly. Check vendor-react bundle.');
  throw new Error('React is not available');
}

const container = document.getElementById("root");
if (!container) {
  throw new Error('Root container not found');
}

const root = createRoot(container);
root.render(<App />);
